import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FiMenu, FiX, FiPhone, FiMail, FiChevronDown } from 'react-icons/fi';
import { FaFacebookF, FaLinkedinIn, FaInstagram } from 'react-icons/fa';
import { useModal } from '../../context/ModalContext';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { openModal } = useModal();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <header className="fixed w-full z-50">
      {/* Top Bar */}
      <div className="bg-dark-800 text-white py-2 hidden lg:block">
        <div className="container flex items-center justify-between">
          <div className="text-sm text-white/80">
            <span>India's Leading Solar Energy Solutions Provider</span>
          </div>
          <div className="flex items-center gap-6">
            <a href="tel:+919527622727" className="flex items-center gap-2 text-sm text-white/80 hover:text-solar-400 transition-colors">
              <FiPhone className="text-solar-400" /> +91 95276 22727
            </a>
            <a href="mailto:nathkrupaenergy@gmail.com" className="flex items-center gap-2 text-sm text-white/80 hover:text-solar-400 transition-colors">
              <FiMail className="text-solar-400" /> nathkrupaenergy@gmail.com
            </a>
          </div>
          <div className="flex items-center gap-3">
            <a href="https://www.facebook.com/profile.php?id=100067472019871" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-white/70 hover:text-solar-400 transition-colors"><FaFacebookF /></a>
            <a href="https://www.linkedin.com/company/nathkrupa-energy-pvt-ltd/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-white/70 hover:text-solar-400 transition-colors"><FaLinkedinIn /></a>
            <a href="https://www.instagram.com/nathkrupa_energy_pvt.ltd/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-white/70 hover:text-solar-400 transition-colors"><FaInstagram /></a>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <nav className={`transition-all duration-300 ${scrolled ? 'bg-white shadow-lg py-3' : 'bg-white/95 backdrop-blur-sm py-4'}`}>
        <div className="container flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" onClick={closeMenu}>
            <img 
              src="/NathKrupaLogo.jpeg" 
              alt="Nath Krupa Energy" 
              className="h-10 md:h-12 w-auto scale-125 object-contain transition-transform duration-300 hover:scale-125"
            />
          </Link>

          <ul className={`lg:flex items-center gap-1 ${isOpen ? 'absolute top-full left-0 right-0 bg-white shadow-lg flex flex-col p-5 max-h-[80vh] overflow-y-auto' : 'hidden'}`}>
            <li>
              <NavLink 
                to="/" 
                onClick={closeMenu}
                className={({isActive}) => `block px-4 py-2 font-heading font-semibold text-sm uppercase tracking-wide transition-colors ${isActive ? 'text-primary-500' : 'text-dark-700 hover:text-primary-500'}`}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/about" 
                onClick={closeMenu}
                className={({isActive}) => `flex items-center gap-1 px-4 py-2 font-heading font-semibold text-sm uppercase tracking-wide transition-colors ${isActive ? 'text-primary-500' : 'text-dark-700 hover:text-primary-500'}`}
              >
                About Us <FiChevronDown className="text-xs" />
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/products" 
                onClick={closeMenu}
                className={({isActive}) => `flex items-center gap-1 px-4 py-2 font-heading font-semibold text-sm uppercase tracking-wide transition-colors ${isActive ? 'text-primary-500' : 'text-dark-700 hover:text-primary-500'}`}
              >
                Products <FiChevronDown className="text-xs" />
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/services" 
                onClick={closeMenu}
                className={({isActive}) => `block px-4 py-2 font-heading font-semibold text-sm uppercase tracking-wide transition-colors ${isActive ? 'text-primary-500' : 'text-dark-700 hover:text-primary-500'}`}
              >
                Services
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/contact" 
                onClick={closeMenu}
                className={({isActive}) => `block px-4 py-2 font-heading font-semibold text-sm uppercase tracking-wide transition-colors ${isActive ? 'text-primary-500' : 'text-dark-700 hover:text-primary-500'}`}
              >
                Contact Us
              </NavLink>
            </li>
            <li className="lg:hidden mt-2 pt-3 border-t border-gray-200 w-full">
              <button
                onClick={() => { openModal(); closeMenu(); }}
                className="w-full inline-flex items-center justify-center gap-2 bg-gradient-to-r from-primary-500 to-primary-600 text-white px-6 py-3 font-heading font-semibold text-sm uppercase tracking-wide rounded-lg"
              >
                Get Quote
              </button>
            </li>
          </ul>

          <div className="flex items-center gap-4">
            <button
              onClick={() => { openModal(); closeMenu(); }}
              className="hidden lg:inline-flex items-center gap-2 bg-gradient-to-r from-primary-500 to-primary-600 text-white px-6 py-3 font-heading font-semibold text-sm uppercase tracking-wide hover:from-primary-600 hover:to-primary-700 transition-all shadow-md hover:shadow-lg rounded-lg"
            >
              Get Quote
            </button>
            <button 
              className="lg:hidden text-2xl text-dark-800 p-2 rounded-lg" 
              onClick={toggleMenu} 
              aria-label="Toggle Menu"
            >
              {isOpen ? <FiX /> : <FiMenu />}
            </button>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
